<ng-template #titleTemplate>
  <h1 class="app-row" [innerText]="projectTitle"></h1>
  <div class="app-row sub-head">
    <div class="btn-group btn-group-toggle" data-toggle="buttons">
      <button [class.active]="mapButton.name === mapBackground?.name" class="btn btn-sm btn-primary btn-group-toggle"
        (click)="SelectBackground(mapButton)" *ngFor="let mapButton of mapBackgrounds;index as bg"><span
          [class]="mapButton.icon"></span></button>
    </div>
    <div class="btn-group btn-group-toggle" data-toggle="buttons" *ngIf="mapReady">
      <button [class.active]="mapMode === 'view'" class="btn btn-sm btn-primary btn-group-toggle"
        (click)="SetMapMode('view')">
        <span class="fas fa-eye"></span>
      </button>
      <button [class.active]="mapMode === 'edit'" class="btn btn-sm btn-primary btn-group-toggle"
        (click)="SetMapMode('edit')">
        <span class="fas fa-pencil"></span>
      </button>
    </div>
    <div class="btn-group btn-group-toggle" data-toggle="buttons">
      <button [class.active]="displayMode === 'map'" class="btn btn-sm btn-primary btn-group-toggle"
        (click)="SetDisplayMode('map')">
        <span class="fas fa-map active"></span>
      </button>
      <button [class.active]="displayMode === 'report'" class="btn btn-sm btn-primary btn-group-toggle"
        (click)="SetDisplayMode('report')">
        <span class="fas fa-table"></span>
      </button>
      <button [class.active]="displayMode === 'hybrid'" class="btn btn-sm btn-primary btn-group-toggle"
        (click)="SetDisplayMode('hybrid')">
        <span class="fas fa-tv"></span>
      </button>
    </div>

  </div>
</ng-template>
<div #mainWorkPane class="main-work-pane">
  <div class="tryptic">
    <div class="left-pane work-pane">
      <app-report-nav  [route]="currentRoute"></app-report-nav>
      <app-layer-list [project]="project" [drawMode]="mapMode" #layerList (onSelect)="SelectRoute($event)"
        (onRemoval)="RemoveRouteLayer($event)"></app-layer-list>

    </div>

    <div class="center-pane">
      <div class="mapping">
        <app-map #map [mode]="mapMode" [project]="project" [background]="mapBackground" (onMapLoaded)="HandleMap()"
          [spatialContext]="spatialContext">

        </app-map>
      </div>
      <div class="reporting">
        <app-reports (reportModeChange)="ShowReports()" #reports [route]="currentRoute"></app-reports>
      </div>
    </div>

    <div class="entry-pane work-pane">
      <app-data-entry [data]="selected"></app-data-entry>
    </div>

  </div>
</div>
